import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { VehicleBookingService } from '../vehicle-booking.service';
import { VehicleBooking } from '../vehicle-booking';
import { VehicleBookingComponent } from '../vehicle-booking/vehicle-booking.component';
import {ActivatedRoute} from '@angular/router';
import * as moment from 'moment-timezone';

@Component({
    selector: 'app-vehicle-booking-list',
    templateUrl: './vehicle-booking-list.component.html',
    styleUrls: ['./vehicle-booking-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class VehicleBookingListComponent implements OnInit {
	vehicles: any;
	constructor(
		private vehicleBookingService: VehicleBookingService,
		private alertService: AlertService,
    private route: ActivatedRoute,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
    this.vehicleBookingId = this.route.snapshot.params['vehicleBookingId'];
		this.statuses = vehicleBookingService.statuses;
		this.vehicles = vehicleBookingService.vehicles;
		this.pickupDrops = vehicleBookingService.pickupDrops;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() reservationId: any;
	@Input() reservation: any;
	vehicleBookings: any;
	vehicleBooking: VehicleBooking;
  vehicleBookingId: any;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [];

	pickupDrops: any;

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
			
			// Check if vehicleBookingId is provided in route and open edit dialog
			if (this.vehicleBookingId) {
				this.openEditDialogForVehicleBookingId();
			}
		}
		catch (error) {
			console.log('Error: ' + error);
		}
		this.setupColumns();
	}

	setupColumns() {
		this.columns = [
			{ field: 'vehiclePref', header: 'Vehicle', width: 'auto', condition: true, sortable: true },
			{ field: 'agencyConfNumber', header: 'Conf Number', width: 'auto', condition: true, sortable: false },
			{ field: 'retailUpgradeCostPerDay', header: 'Rtl Cost/Day', width: 'auto', condition: true, sortable: true },
			{ field: 'bookingStatus', header: 'Status', width: 'auto', condition: true, sortable: true },
			// { field: 'pickUpLocPref', header: 'PickUp Location Pref', width: 'auto', condition: !this.reservationId },
			// { field: 'dropOffLocPref', header: 'DropOff Location Pref', width: 'auto', condition: !this.reservationId },
			{ field: 'pickUpDateTimePref', header: 'PickUp', width: 'auto', condition: true, sortable: true },
			{ field: 'dropOffDateTimePref', header: 'DropOff', width: 'auto', condition: true, sortable: true },
			{ field: 'primaryDriverName', header: 'Driver Name', width: 'auto', condition: !this.reservationId, sortable: true },
			{ field: 'cancelDate', header: 'Cancel Date', width: 'auto', condition: true, sortable: true },
			{ field: 'createDate', header: 'Created Date', width: 'auto', condition: true, sortable: true },
		];
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.vehicleBookingId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort - Only apply if no user interaction has occurred
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-vehicleBooking-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			if (this.reservationId) {
				// show only shortTermRentals that are assigned to this propertyCodeFilter
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			if (event.filters?.pickUpDateTimePref?.value) {
				event.filters.pickUpDateTimePref.value = moment(event.filters.pickUpDateTimePref.value)
					.startOf('day')
					.format('YYYY-MM-DD[T]HH:mm:ss');
			}

			if (event.filters?.dropOffDateTimePref?.value) {
				event.filters.dropOffDateTimePref.value = moment(event.filters.dropOffDateTimePref.value)
					.startOf('day')
					.format('YYYY-MM-DD[T]HH:mm:ss');
			}


			const pageNumber = Math.round(event.first / event.rows);
			this.vehicleBookingService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.vehicleBookings = res.data.vehicleBookings;
						console.log(JSON.stringify(res.page));
						this.vehicleBookings = this.vehicleBookings.map(vb => ({
							...vb,
							formattedPickUpDateTimePref: this.formatDateTime(vb.pickUpDateTimePref),
							formattedDropOffDateTimePref: this.formatDateTime(vb.dropOffDateTimePref),
							formattedCancelDate: this.formatDateTime(vb.cancelDate),
							formattedCreatedDate: this.formatDateTime(vb.createDate)
						}));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.vehicleBookings = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

  private formatToApiIso(dateTimeLocal: string): string | null {
    if (!dateTimeLocal) return null;
    // dateTimeLocal expected like '2025-10-15T14:37'
    const date = new Date(dateTimeLocal);
    if (isNaN(date.getTime())) return null;
    return date.toISOString(); // e.g., 2025-10-15T14:37:00.000Z
	}
	
	getVehicleName(vehiclePref: any) {
		if(vehiclePref != undefined){
			return this.vehicles.find((e: any) => e.value == vehiclePref)?.name || vehiclePref;
		}
		return '';
	}

	getPickupDropName(pickupDropPref: any) {
		if(pickupDropPref != undefined){
			return this.pickupDrops.find((e: any) => e.value == pickupDropPref)?.name || pickupDropPref;
		}
		return '';
	}


  private formatToDisplay(value: string): string {
    // value is ISO or datetime-local string; return 'MM/DD/YY h:mm AM/PM'
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');
    const yy = d.getFullYear().toString().slice(-2);
    let hours = d.getHours();
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if (hours === 0) hours = 12;
    return `${mm}/${dd}/${yy} ${hours}:${minutes} ${ampm}`;
  }

  onPickUpDateTimeInput(value: string, table: any) {
    const formatted = this.formatToDisplay(value);
    table.filter(formatted || null, 'pickUpDateTimePref', 'in');
  }

  onDropOffDateTimeInput(value: string, table: any) {
    const formatted = this.formatToDisplay(value);
    table.filter(formatted || null, 'dropOffDateTimePref', 'in');
  }

	
	onDateTimeInput(value: string, table: any, field: string) {
		const formatted = this.formatToDisplay(value);
		table.filter(formatted || null, field, 'in');
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(vehicleBooking: VehicleBooking) {
		try {
			this.formLoading = true;
			this.vehicleBookingService.update(vehicleBooking)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.vehicleBookings.map((vehicleBooking, i) => {
							if (vehicleBooking.vehicleBookingId === res.data.vehicleBooking.vehicleBookingId) {
								this.vehicleBookings[i] = res.data.vehicleBooking;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(vehicleBooking: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(vehicleBooking));

			this.formLoading = true;
			this.vehicleBookingService.delete(vehicleBooking.vehicleBookingId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.vehicleBookings.splice(this.vehicleBookings.indexOf(vehicleBooking), 1);
						this.recordTotal = this.vehicleBookings.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'VehicleBooking ' + vehicleBooking.vehicleBookingId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'VehicleBooking ' + vehicleBooking.vehicleBookingId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '80%';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Vehicle Booking',
			reservation: this.reservation,
			reservationId: this.reservationId,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(VehicleBookingComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);
				data.formattedPickUpDateTimePref = this.formatDateTime(data.pickUpDateTimePref);
				data.formattedDropOffDateTimePref = this.formatDateTime(data.dropOffDateTimePref);
				data.formattedCancelDate = this.formatDateTime(data.cancelDate);
				data.formattedCreatedDate = this.formatDateTime(data.createDate);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addVehicleBookingCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(vehicleBooking: VehicleBooking) {

		const dialogConfig = new MatDialogConfig();
		const vehicleBookingObj = vehicleBooking;

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '90%';
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			vehicleBooking: vehicleBookingObj,
			title: 'Edit Vehicle Booking'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(VehicleBookingComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				data.formattedPickUpDateTimePref = this.formatDateTime(data.pickUpDateTimePref);
				data.formattedDropOffDateTimePref = this.formatDateTime(data.dropOffDateTimePref);
				data.formattedCancelDate = this.formatDateTime(data.cancelDate);
				data.formattedCreatedDate = this.formatDateTime(data.createDate);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateVehicleBookingCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteVehicleBookingCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addVehicleBookingCB(vehicleBooking: VehicleBooking) {
		console.log('Adding VehicleBooking: ' + JSON.stringify(vehicleBooking));
		// if we don't have a vehicleBookings array yet...
		if (!this.vehicleBookings) {
			this.vehicleBookings = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.vehicleBookings.unshift(vehicleBooking);

		// no idea what this is but it is required to update the array
		this.vehicleBookings = [...this.vehicleBookings];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'VehicleBooking ' + vehicleBooking.vehicleBookingId + ' Added', life: 3000 });
	}

	updateVehicleBookingCB(vehicleBooking: VehicleBooking) {
		console.log('Updating VehicleBooking: ' + JSON.stringify(vehicleBooking));
		let itemIndex = this.vehicleBookings.findIndex((item: any) => item.vehicleBookingId === vehicleBooking.vehicleBookingId);
		this.vehicleBookings[itemIndex] = vehicleBooking;

		// no idea what this is but it is required to update the array
		this.vehicleBookings = [...this.vehicleBookings];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'VehicleBooking ' + vehicleBooking.vehicleBookingId + ' Updated', life: 3000 });
	}

	deleteVehicleBookingCB(vehicleBooking: VehicleBooking) {
		console.log('Removing VehicleBooking: ' + vehicleBooking);
		this.vehicleBookings.splice(this.vehicleBookings.indexOf(vehicleBooking), 1);
		this.recordTotal = this.vehicleBookings.length;

		// no idea what this is but it is required to update the array
		this.vehicleBookings = [...this.vehicleBookings];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'VehicleBooking ' + vehicleBooking.vehicleBookingId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.vehicleBookings ? this.first === (this.vehicleBookings.length - this.rows) : true; }
	isFirstPage(): boolean { return this.vehicleBookings ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(bookingStatus: any) {
		if(bookingStatus != undefined){
			const status = this.statuses.find((e: any) => e.value == bookingStatus);
			return status.name;
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	/*********
	 * Open Edit Dialog for VehicleBookingId from Route
	 * Automatically opens the edit dialog when vehicleBookingId is provided in route
	 */
	openEditDialogForVehicleBookingId() {
		if (!this.vehicleBookingId) {
			return;
		}

		// Fetch the vehicle booking by ID
		this.vehicleBookingService.findById(this.vehicleBookingId)
			.pipe(first())
			.subscribe(
				(res: any) => {
					if (res.data && res.data.vehicleBooking) {
						// Open the edit dialog with the fetched vehicle booking
						this.onOpenFormEdit(res.data.vehicleBooking);
					} else {
						console.log('Vehicle booking not found for ID: ' + this.vehicleBookingId);
						this.messageService.add({ 
							severity: 'warn', 
							summary: 'Not Found', 
							detail: 'Vehicle booking with ID ' + this.vehicleBookingId + ' was not found.', 
							life: 3000 
						});
					}
				},
				(err: any) => {
					console.log('Error fetching vehicle booking: ' + JSON.stringify(err));
					this.messageService.add({ 
						severity: 'error', 
						summary: 'Error', 
						detail: 'Failed to load vehicle booking with ID ' + this.vehicleBookingId, 
						life: 3000 
					});
				}
			);
	}

	getDateTimeBasedOnTimeZone(date: any){
		return moment.utc(date).toDate()
	}

	formatDateTime(dateTimeInput: string | Date): string {
		if (!dateTimeInput) return '';

		let dateTimeStr: string;

		if (dateTimeInput instanceof Date) {
			dateTimeStr = dateTimeInput.toISOString().slice(0, 19); // '2026-03-11T22:00:00'
		} else {
			dateTimeStr = dateTimeInput;
		}

		if (!dateTimeStr.includes('T')) return '';

		const [datePart, timePart] = dateTimeStr.split('T');
		const [year, month, day] = datePart.split('-').map(Number);
		const [hour, minute] = timePart.split(':').map(Number);

		const period = hour >= 12 ? 'PM' : 'AM';
		const hour12 = hour % 12 === 0 ? 12 : hour % 12;

		return `${month}/${day}/${String(year).slice(-2)} ${hour12}:${minute.toString().padStart(2, '0')} ${period}`;
	}


}
